<template>
    <div class="footer--simple-wrapper">
        <slot name="head"></slot>
        <slot name="body"></slot>
    </div>
</template>

<script>
    export default {};
</script>



// WEBPACK FOOTER //
// simple-wrapper.vue?5f2e5bf2